import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {validationsList_template} from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template';

declare var ko: any;

export class topicsEdit_template extends vnTemplate {


    protected getTemplateHtml(): string {
        return `
            <div class="form-header">
                <input id="topic-id" data-bind="value: id" type="hidden">
                <h3 class="form-title icon i-topic-add">Add Topic</h3>
                <button data-bind="event: { click: onClickCancel }" class="close-button icon i-close-2" type="button"></button>
            </div>

            <div class="form-body">
                <strong class="form-sub-title">Topic info</strong>
                
                <div class="form-group">
                    <label for="title" class="form-label">Title<span>*</span></label>
                    <input id="title" data-bind="value: title, valueUpdate: 'keyup', event: { keyup: lookForSimilar }" type="text" class="input-text">
                </div>
                
                <div class="form-group">
                    <table class="list-results in-form" id="list-results">
                        <thead>
                            <tr>
                                <th><span>Title</span></th>
                                <th><span>Status</span></th>
                            </tr>
                        </thead>
                        <tbody data-bind="foreach: similarTopics">
                            <tr>
                                <td data-bind="html: title"></td>
                                <td data-bind="text: status.name"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
             </div>
      
             
             <div class="form-footer">
                <button data-bind="event: { click: onClickSubmit }" class="btn highlight" type="button">Submit Topic</button>
                <button data-bind="event: { click: onClickCancel }" class="btn" type="button">Cancel</button>
            </div>
             `;
    }

    protected getTemplateName(): string {
        return "topicsEdit-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string>{
        return ["w-form"];
    }

    protected buildViewModel(): any {
        let huit_neuf_this = this;
        return {
            id: ko.observable("")
            ,title: ko.observable("")
            ,similarTopics: ko.observableArray([])
            ,onClickSubmit: function(data, event){ huit_neuf_this.onClickSubmit(); }
            ,onClickCancel: function(data, event){ huit_neuf_this.onClickCancel(); }
            ,lookForSimilar: function(data, event){ huit_neuf_this.lookForSimilar(); }
        };
    }

    public updateForm(topic) {
        this.getTemplateViewModel().id(topic.id)
        this.getTemplateViewModel().title(topic.title);
    }

    protected onClickSubmit(){
        this.caller.save();
    }

    protected onClickCancel(){
        this.caller.cancelEditTopic();
    }


    protected lookForSimilar(){
        console.log(this.getTemplateViewModel().title());
        let keyword = this.getTemplateViewModel().title();
        this.caller.getSimilarTopics(keyword);
    }

    public setSimilarTopics(similarTopics)
    {
        let title = this.getTemplateViewModel().title();
        let searchText = title.toLowerCase();
        let keywords = searchText.split(" ");

        for(let kw of keywords) {
            for (let item of similarTopics) {
                var innerHTML = item.title;
                var index = innerHTML.toLowerCase().indexOf(kw);
                if (index >= 0) {
                    innerHTML = innerHTML.substring(0,index) + "\<span class='highlightWord'>" + innerHTML.substring(index,index + kw .length) + "</span>" + innerHTML.substring(index + kw.length);
                    item.title = innerHTML;
                }
            }
        }

        this.getTemplateViewModel().similarTopics(similarTopics)
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/topicsEdit_template.ts